<template>
  <span class="d-flex flex-row f14-l17 df16-l23-m text-align-center m-0 p-0">
    <span class="flex-grow-1"></span>
    <img src="@/assets/icons/rating-star.svg" v-for="i in 5" :key="i" :class="drawClass(i)" />
    &nbsp;<span style="min-width:30px">{{ratingToFix1}}</span><span v-if="count" style="min-width:40px"> ({{count}})</span>
  </span>
</template>
<script>
export default {
  props: {
    rating: {
      type: Number,
      default: 1
    },
    count: Number
  },
  computed: {
    ratingToFix1() {
      if (!this.rating) return 0;
      return this.rating; //.toFixed(1);
    }
  },
  methods: {
    drawClass(val) {
      if (!this.rating) return "star-faded";
      let rating = this.rating.toFixed(0);
      return (val <= rating) ? "star-full" : "star-faded";
    }
  }
}
</script>
<style scoped>
.star-faded {
  opacity: 0.3;
}
</style>